import React from "react";
import {
	Card
} from "reactstrap";
import { Link } from "react-router-dom";

export default function StepFive() {
	return (
		<Card className="p-4 mb-3 visibility-visible">
			<div className="title mb-4">
				<span className="me-2 step-number">5</span>Save
			</div>

			<div className="contact-form-btns">
				<Link
					to="/admin/dashboard"
					className="contact-save-btn btn m-0"
				>
					Save & Go to Dashboard
				</Link>
			</div>
		</Card>
	);
};